<template>
  <b-overlay :show="load" rounded="lg">
    <div class="app-calendar overflow-hidden border">
      <div class="row no-gutters">
        <!-- Calendar -->
        <div class="col position-relative">
          <div class="card shadow-none border-0 mb-0 rounded-0">
            <div class="card-body pb-0">
              <FullCalendar :options="calendarOptions" ref="calendar" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import arLocale from "@fullcalendar/core/locales/ar";

import EduContentRoomController from "@/Controllers/EduContentRoomController";

export default {
  components: {
    FullCalendar,
  },
  data() {
    return {
      load: false,
      calendarOptions: {
        plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
        initialView: "dayGridMonth",
        headerToolbar: {
          start: "sidebarToggle, prev,next, title",
          end: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
        },
        locale: arLocale,
        editable: false,
        droppable: false,
        allDayDefault: false,
        dayMaxEvents: 2,
        views: {
          dayGridMonth: { buttonText: "شهر" },
          timeGridWeek: { buttonText: "أسبوع" },
          listMonth: { buttonText: "يوم" },
          timeGridDay: { buttonText: "قائمة" },
        },
        height: 800,
        contentHeight: 780,
        aspectRatio: 3,
        events: [],
        themeSystem: "bootstrap",
      },
    };
  },
  async mounted() {
    await this.loadEvents();
  },
  methods: {
    async loadEvents() {
      this.load = true;
      const res = await new EduContentRoomController().GetAll({
        with: ["getEduContent", "getRoom"],
        per_page: 10000,
      });
      const items = Array.isArray(res) ? res : (res && res.data) || [];

      const calendarApi = this.$refs.calendar.getApi();
      calendarApi.getEvents().forEach((event) => event.remove());

      items.forEach((item) => {
        const content = item.get_edu_content || {};
        const room = item.get_room || {};
        calendarApi.addEvent({
          id: item.id,
          title: content.name || room.name || "—",
          start: item.start_in,
          end: item.end_in,
          className: "fc-event-danger fc-event-solid-warning",
          extendedProps: {
            type: content.type,
            room: room.name,
            description: content.description,
            online_class_id: item.online_class_id,
          },
        });
      });

      this.load = false;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";

.app-calendar .fc .fc-event .fc-event-main {
  text-align: center;
  color: #fff;
}
</style>
